import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import fields from '@/sui/data/sheets/edit/fields'
import assert from '@/sui/tools/assert'
import go from '@/gojs/go'
import clone from 'clone'

import {
  checkAge,
  checkDate,
  checkCompresses,
  checkB2Gloves,
  checkDeviceInsertionSite,
  checkProbeTouchedWithGloves,
  checkBMI,
  checkP1Chlorex,
  checkSecondManipType,
  checkHeadFaceSterileField
} from '@/sui/data/sheets/edit/notes/observa4'

import v2023 from '@/sui/data/sheets/edit/observa4/2023'
const result = clone(v2023)

//     UPDATE    p2type (list)          p2type>config>values>0>value: different values (7. CVP court / 7. CVP court sans prolongateur)
result.fields.catheterType.p2.config.values = go.fields.p2Type

// >>> UPDATE    p4type (list)          p4type>config>values: different sizes
result.fields.catheterType.p4.config.values = go.fields.p4Type

// >>> UPDATE    b1type (list)          b1type>config>values: different sizes
result.fields.catheterType.b1.config.values = go.fields2024.b1Type

// --- REMOVE    b1otherCatheterType (text)
delete result.fields.otherCatheterType.b1

// --- REMOVE    b2otherCatheterType (text)
delete result.fields.otherCatheterType.b2

// --- REMOVE    firstDressing (list)
delete result.fields.firstDressing

// --- REMOVE    insertionDate (date)
delete result.fields.insertionDate

// --- REMOVE    lastDressingDate (date)
delete result.fields.lastDressingDate

// +++ ADD       secondManipType (list)
result.fields.secondManipType = {
  b2: tools.cfg.list(
    fields.secondManipType, 'Second type de manipulation (Optionnel)',
    go.fields.manipType, { sel: result.select.b2, op: true }
  )
}

// +++ ADD       secondOtherManipType (text)
result.fields.secondOtherManipType = {
  b2: tools.cfg.text(
    fields.secondOtherManipType, 'Préciser le second type de manipulation',
    { sel: tools.equals(fields.secondManipType, 6) }
  )
}

//     UPDATE    auditedCleanOutfitOrProt (list)auditedCleanOutfitOrProt>selectList>0/0: different function names "(obsManagment === 7)" "allTrue ((obsManagment === 7), not ((unitTypeMatch /^NEO/)))}"
result.fields.auditedCleanOutfitOrProt.r1 = tools.select(
  result.fields.auditedCleanOutfitOrProt.r1,
  tools.allTrue(
    result.select.r1,
    tools.not(patient.select.isNeo)
  )
)

// +++ ADD       r1sterileGown (list)
result.fields.sterileGown.r1 = tools.cfg.list(
  `r1${fields.sterileGown}`,
  result.fields.sterileGown.p1.config.title,
  result.fields.sterileGown.p1.config.values, {
    sel: tools.allTrue(result.select.r1, patient.select.isNeo),
    srv: fields.sterileGown
  }
)

// +++ ADD       b2auditedCap (list)
result.fields.auditedCap.b2 = tools.cfg.list(
  `b2${fields.auditedCap}`,
  result.fields.auditedCap.p1p3r1.config.title,
  result.fields.auditedCap.p1p3r1.config.values, {
    sel: tools.allTrue(result.select.b2, patient.select.isNeo),
    srv: fields.auditedCap
  }
)

// +++ ADD       b2compliantAuditedCap (list)
result.fields.compliantAuditedCap.b2 = tools.cfg.list(
  `b2${fields.compliantAuditedCap}`,
  result.fields.compliantAuditedCap.p1p3r1.config.title,
  result.fields.compliantAuditedCap.p1p3r1.config.values, {
    sel: result.select.yes(result.fields.auditedCap.b2.field),
    srv: fields.compliantAuditedCap
  }
)

// +++ ADD       patientHeadSterileField (list)
result.fields.patientHeadSterileField = {
  p1: tools.cfg.list(
    fields.patientHeadSterileField,
    `La tête est-elle couverte par un champ stérile ?`,
    go.fields.yesNo, {
      sel: tools.allTrue(result.select.p1, result.select.no(result.fields.patientCap.p1.field))
    }
  )
}

// --- REMOVE    ultrasoundPrepared (list)
delete result.fields.ultrasoundPrepared

// --- REMOVE    usAuditedPreparation (list)
delete result.fields.usAuditedPreparation

// --- REMOVE    handHygieneBeforeP1UltrasoundPreparation (list)
// --- REMOVE    handHygieneBeforeP1UltrasoundPreparationType (list)
// --- REMOVE    handHygieneBeforeP1UltrasoundPreparationCompliant (list)
delete result.fields.handHygieneBeforeP1UltrasoundPreparation

// --- REMOVE    ultrasoundWipingPrepa (list)
delete result.fields.ultrasoundWipingPrepa

// --- REMOVE    ultrasoundWipingPrepaProduct (list)
delete result.fields.ultrasoundWipingPrepaProduct

// --- REMOVE    ultrasoundWipingPrepaProductDetail (text)
delete result.fields.ultrasoundWipingPrepaProductDetail

// --- REMOVE    handHygieneBeforeP1UltrasoundSearch (list)
// --- REMOVE    handHygieneBeforeP1UltrasoundSearchType (list)
// --- REMOVE    handHygieneBeforeP1UltrasoundSearchCompliant (list)
delete result.fields.handHygieneBeforeP1UltrasoundSearch

// --- REMOVE    p1searchgloves (list)
delete result.fields.searchGloves

// --- REMOVE    p1searchglovesType (list)
delete result.fields.searchGlovesType

// >>> UPDATE    vialOpenedSince (list) vialOpenedSince>selectList>0/0: different function names "(searchgelUsed === 3)" "(vialOpeningDateWritten === 1)}"
result.fields.vialOpenedSince.p1 = tools.select(
  result.fields.vialOpenedSince.p1,
  tools.equals(result.fields.searchGelUsed.p1.field, 3)
)
// >>> UPDATE    ultrasoundWipingSearch (list)ultrasoundWipingSearch>selectList>0/0: different function names "allTrue ((usAuditedSearch === 1), oneTrue ((searchultrasoundSheath === 3), (sheathRemoval === 1)))" "(usAuditedSearch === 1)}"
result.fields.ultrasoundWipingSearch.p1[0] = tools.select(
  result.fields.ultrasoundWipingSearch.p1[0],
  tools.allTrue(
    result.select.yes(result.fields.usAuditedSearch.p1.field),
    tools.oneTrue(
      tools.equals(result.fields.searchUltrasoundSheath.p1.field, 3),
      result.select.yes(result.fields.sheathRemoval.p1.field)
    )
  )
)

// >>> UPDATE    handHygieneBeforeEquipmentPreparation (list)handHygieneBeforeEquipmentPreparation>selectList>0/0: different function names "(obsManagment === 7)" "oneTrue ((obsManagment === 5), (obsManagment === 7))}"
result.rename(result.fields.handHygieneBeforeEquipmentPreparation, 'b2r1', 'r1')
result.fields.handHygieneBeforeEquipmentPreparation.r1[0] = tools.select(
  result.fields.handHygieneBeforeEquipmentPreparation.r1[0], result.select.r1
)

// --- REMOVE    dressingWithCompresses (list)
delete result.fields.dressingWithCompresses

// --- REMOVE    sterileSemiPermeableTransparent (list)
delete result.fields.sterileSemiPermeableTransparent

// REMOVE    handHygieneBeforePreparation (list)
// --- REMOVE    handHygieneBeforePreparationType (list)
// --- REMOVE    handHygieneBeforePreparationCompliant (list)
delete result.fields.handHygieneBeforePreparation

// --- REMOVE    handHygieneBeforeManip (list)
// --- REMOVE    handHygieneBeforeManipType (list)
// --- REMOVE    handHygieneBeforeManipCompliant (list)
delete result.fields.handHygieneBeforeManip

//     UPDATE    r1removalgloves (list) r1removalgloves>config>title: different values (Gants enfilés pour le retrait du pansement / Port des gants pour le retrait du pansement en place)
result.fields.removalGloves.r1.config.title = 'Port des gants pour le retrait du pansement en place'

// +++ ADD       handHygieneBeforeAntisepsis (list)
// +++ ADD       handHygieneBeforeAntisepsisType (list)
// +++ ADD       handHygieneBeforeAntisepsisCompliant (list)
result.fields.handHygieneBeforeAntisepsis = {
  p4: result.build.handHygiene(
    fields.handHygiene, 'BeforeAntisepsis',
    `immédiatement avant l'antisepsie`,
    result.select.p4, null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       handHygieneBeforeB1Disinfection (list)
// +++ ADD       handHygieneBeforeB1DisinfectionType (list)
// +++ ADD       handHygieneBeforeB1DisinfectionCompliant (list)
result.fields.handHygieneBeforeDisinfection = {
  b1: result.build.handHygiene(
    fields.handHygiene, 'BeforeB1Disinfection',
    `faite avant la désinfection de la connectique`,
    result.select.b1, null,
    go.fields.handHygieneTypeSimple
  )
}

// --- REMOVE    handHygieneAfterR1Gloves (list)
// --- REMOVE    handHygieneAfterR1GlovesType (list)
// --- REMOVE    handHygieneAfterR1GlovesCompliant (list)
delete result.fields.handHygieneAfterR1Gloves

// +++ ADD       handHygieneBeforeStabilizer (list)
// +++ ADD       handHygieneBeforeStabilizerType (list)
// +++ ADD       handHygieneBeforeStabilizerCompliant (list)
result.fields.handHygieneBeforeStabilizer = {
  r1: result.build.handHygiene(
    fields.secondaryHandHygiene, 'BeforeStabilizer',
    'avant le retrait du stabilisateur',
    tools.allTrue(
      result.select.r1,
      result.select.yes(result.fields.changeStabilizer.r1.field),
      result.select.noGloves('r1', 'stabilizer')
    ),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// >>> UPDATE    r1stabilizergloves (list)r1stabilizergloves>config>title: different values (Ports des gants pour le retrait / Gants enfilés pour le retrait du stabilisateur)
result.fields.stabilizerGloves.r1.config.title = 'Ports des gants pour le retrait'

// +++ ADD       handHygieneBeforeR1Antisepsis (list)
// +++ ADD       handHygieneBeforeR1AntisepsisType (list)
// +++ ADD       handHygieneBeforeR1AntisepsisCompliant (list)
result.fields.handHygieneBeforeAntisepsis.r1 = result.build.handHygiene(
  fields.fourthHandHygiene, 'BeforeR1Antisepsis', `immédiatement avant l'antisepsie`,
  tools.allTrue(result.select.r1, result.select.noGloves('r1', 'repair')),
  null, go.fields.handHygieneTypeSimple
)

// >>> UPDATE    r1repairgloves (list)  r1repairgloves>config>title: different values (Port des gants pour l'antisepsie / Gants enfilés pour l'antisepsie)
result.fields.repairGloves.r1.config.title = `Port des gants pour l'antisepsie`

// --- REMOVE    handHygieneAfterR1StabilizerGloves (list)
// --- REMOVE    handHygieneAfterR1StabilizerGlovesType (list)
// --- REMOVE    handHygieneAfterR1StabilizerGlovesCompliant (list)
delete result.fields.handHygieneAfterR1StabilizerGloves

// --- REMOVE    dressingSet (list)
delete result.fields.dressingSet

// --- REMOVE    auditedCleanSkin (list)
delete result.fields.auditedCleanSkin

// --- REMOVE    handHygieneBeforeP1SkinCleaning (list)
// --- REMOVE    handHygieneBeforeP1SkinCleaningType (list)
// --- REMOVE    handHygieneBeforeP1SkinCleaningCompliant (list)
delete result.fields.handHygieneBeforeP1SkinCleaning

// --- REMOVE    p1skingloves (list)
delete result.fields.skinGloves

// --- REMOVE    p1skinglovesType (list)
delete result.fields.skinGlovesType

// --- REMOVE    p1secondaryGlovesRemoval (list)
delete result.fields.secondaryGlovesRemoval.p1

// >>> UPDATE    r1UseCompresses (list) r1UseCompresses>selectList>0/0: different function names "allTrue ((obsManagment === 7), (r1AntisepticApplied === 1))" "allTrue ((obsManagment === 7), (r1AntisepticApplied === 1), (r1Antiseptic != null && r1Antiseptic !== 7))}"
result.fields.useCompresses.r1 = tools.select(
  result.fields.useCompresses.r1,
  tools.allTrue(result.select.r1, result.select.yes(result.fields.antiseptic.r1[0].field))
)

// --- REMOVE    auditedApplyASQ (list)
delete result.fields.auditedApplyASQ

// --- REMOVE    handHygieneBeforeP1Antiseptic (list)
// --- REMOVE    handHygieneBeforeP1AntisepticType (list)
// --- REMOVE    handHygieneBeforeP1AntisepticCompliant (list)
delete result.fields.handHygieneBeforeP1Antiseptic

// --- REMOVE    p1antisepticgloves (list)
delete result.fields.antisepticGloves

// --- REMOVE    p1antisepticglovesType (list)
delete result.fields.antisepticGlovesType

// --- REMOVE    p1thirdGlovesRemoval (list)
delete result.fields.thirdGlovesRemoval.p1

// --- REMOVE    handHygieneAfterR1RepairGloves (list)
// --- REMOVE    handHygieneAfterR1RepairGlovesType (list)
// --- REMOVE    handHygieneAfterR1RepairGlovesCompliant (list)
delete result.fields.handHygieneAfterR1RepairGloves

// --- REMOVE    handHygieneBeforeB2Manip (list)
// --- REMOVE    handHygieneBeforeB2ManipType (list)
// --- REMOVE    handHygieneBeforeB2ManipCompliant (list)
delete result.fields.handHygieneBeforeB2Manip

// --- REMOVE    newStabilizer (list)
delete result.fields.newStabilizer

// --- REMOVE    antiPeelingProduct (list)
delete result.fields.antiPeelingProduct

// --- REMOVE    newDressingWithCompresses (list)
delete result.fields.newDressingWithCompresses

// --- REMOVE    newDressingSterileSemiPermeableTransparent (list)
delete result.fields.newDressingSterileSemiPermeableTransparent

// --- REMOVE    newDressingImpregnated (list)
delete result.fields.newDressingImpregnated

// --- REMOVE    r1fourthGlovesRemoval (list)
delete result.fields.fourthGlovesRemoval.r1

// --- REMOVE    handHygieneAfterR1ImplementationGloves (list)
// --- REMOVE    handHygieneAfterR1ImplementationGlovesType (list)
// --- REMOVE    handHygieneAfterR1ImplementationGlovesCompliant (list)
delete result.fields.handHygieneAfterR1ImplementationGloves

// >>> UPDATE    antisepticPassages (list)antisepticPassages>selectList>0/0: different function names "allTrue ((obsManagment === 6), (p1p2p3p4AntisepticApplied === 1))" "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 6)), (p1p2p3p4AntisepticApplied === 1))}"
result.fields.antisepticPassages = {
  p4: tools.select(
    result.fields.antisepticPassages.p1p2p3p4,
    tools.allTrue(
      result.select.p4,
      result.select.yes(result.fields.antiseptic.p1p2p3p4[0].field)
    )
  )
}

// +++ ADD       p1gloves (list)
// +++ ADD       p2p3gloves (list)
// +++ ADD       b1gloves (list)
// +++ ADD       p4gloves (list)
// --- REMOVE    p2p3p4b1gloves (list)
result.fields.gloves = (function () {
  const reference = result.fields.gloves.b2
  const t = reference.config.title
  const v = reference.config.values

  return {
    b2: result.fields.gloves.b2,

    p1: tools.cfg.list(
      `p1${fields.gloves}`,
      `L'opérateur porte-t-il des gants au moment de l'insertion ?`,
      v, { sel: result.select.p1, srv: fields.gloves }
    ),

    p2p3: tools.cfg.list(
      `p2p3${fields.gloves}`, t, v, { sel: result.select.p2p3, srv: fields.gloves }
    ),

    b1: tools.cfg.list(
      `b1${fields.gloves}`, `Port de gants pour la désinfection du site de branchement`,
      v, { sel: result.select.b1, srv: fields.gloves }
    ),

    p4: tools.cfg.list(
      `p4${fields.gloves}`, t, v, { sel: result.select.p4, srv: fields.gloves }
    )
  }
})()

// +++ ADD       p1glovesType (list)
// +++ ADD       p2p3b1glovesType (list)
// +++ ADD       p4glovesType (list)
// --- REMOVE    p2p3p4b1glovesType (list)
result.fields.glovesType = (function () {
  const reference = result.fields.glovesType.b2
  const t = reference.config.title
  const v = reference.config.values

  return {
    b2: result.fields.glovesType.b2,
    p1: tools.cfg.list(
      `p1${fields.glovesType}`, t, v, {
        sel: tools.allTrue(
          result.fields.gloves.p1.selectList._list[0],
          result.select.yes(result.fields.gloves.p1.field)
        ),
        srv: fields.glovesType
      }
    ),

    p2p3b1: tools.cfg.list(
      `p2p3b1${fields.glovesType}`, t, v, {
        sel: tools.oneTrue(
          tools.allTrue(
            result.select.p2p3,
            result.select.yes(result.fields.gloves.p2p3.field)
          ),
          tools.allTrue(
            result.select.b1,
            result.select.yes(result.fields.gloves.b1.field)
          )
        ),
        srv: fields.glovesType
      }
    ),

    p4: tools.cfg.list(
      `p4${fields.glovesType}`, t, v, {
        sel: tools.allTrue(
          result.fields.gloves.p4.selectList._list[0],
          result.select.yes(result.fields.gloves.p4.field)
        ),
        srv: fields.glovesType
      }
    )
  }
})()

// +++ ADD       p1glovesPutOn (list)
// >>> UPDATE    glovesPutOn (list)     glovesPutOn>config>values>0>value: different values (1. Avant la préparation du matériel et/ou l'installation du patient / 1. Avant la préparation du matériel)
// >>> UPDATE    glovesPutOn (list)     glovesPutOn>contextualize: not a Function
// >>> UPDATE    glovesPutOn (list)     glovesPutOn>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 3)), (p2p3gloves === 1))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 3), (obsManagment === 6)), (p2p3p4b1gloves === 1))}"
result.fields.glovesPutOn = (function () {
  const reference = result.fields.glovesPutOn.p2p3p4
  const t = reference.config.title
  const select = result.select
  function ctx (sheet) {
    assert(
      select.p2p3(sheet, sheet),
      `Invalid context for field «${this.config.title}»`
    )
    const prefix = select.p2(sheet, sheet) ? 'p2' : 'p3'
    return {
      values: go.fields[`${prefix}GlovesPutOn`]
    }
  }

  return {
    p1: tools.cfg.list(
      `p1${fields.glovesPutOn}`, t, go.fields.p1glovesPutOn, {
        sel: tools.allTrue(
          result.select.p1,
          result.select.yes(result.fields.gloves.p1.field)
        ),
        srv: fields.glovesPutOn
      }
    ),

    p2p3: tools.cfg.list(
      reference.field, t, go.fields.glovesPutOn, {
        sel: tools.allTrue(
          result.select.p2p3,
          result.select.yes(result.fields.gloves.p2p3.field)
        ),
        ctx: ctx
      }
    )
  }
})()

// --- REMOVE    handHygieneBeforeInsertion (list)
// --- REMOVE    handHygieneBeforeInsertionType (list)
// --- REMOVE    handHygieneBeforeInsertionCompliant (list)
delete result.fields.handHygieneBeforeInsertion

// +++ ADD       handHygieneBeforeInsertionGloves (list)
// +++ ADD       handHygieneBeforeInsertionGlovesType (list)
// +++ ADD       handHygieneBeforeInsertionGlovesCompliant (list)
result.fields.handHygieneBeforeInsertionGloves = {
  p1: result.build.handHygiene(
    fields.handHygiene, 'BeforeInsertionGloves', `avant d'enfiler les gants utilisés à l'insertion`,
    tools.allTrue(result.select.p1, result.select.yes(result.fields.gloves.p1.field)),
    null, go.fields.handHygieneType
  )
}

// +++ ADD       handHygieneBeforeP2Preparation (list)
// +++ ADD       handHygieneBeforeP2PreparationType (list)
// +++ ADD       handHygieneBeforeP2PreparationCompliant (list)
result.fields.handHygieneBeforePreparation = {
  p2: result.build.handHygiene(
    fields.handHygiene, 'BeforeP2Preparation',
    'avant la préparation du matériel et/ou avant la préparation du site',
    result.select.p2, null, go.fields.handHygieneTypeSimple
  )
}

// >>> UPDATE    handHygieneBeforePeriInsertion (list)handHygieneBeforePeriInsertion>selectList>0/0: different function names "oneTrue ((obsManagment === 6), allTrue ((obsManagment === 2), oneTrue (not (allTrue (oneTrue ((obsManagment === 2), (obsManagment === 3)), (p2p3gloves === 1))), (glovesPutOn === 3))))" "oneTrue ((obsManagment === 2), (obsManagment === 6))}"
result.fields.handHygieneBeforePeriInsertion.p2p4[0] = tools.select(
  result.fields.handHygieneBeforePeriInsertion.p2p4[0],
  tools.oneTrue(
    result.select.p4,
    tools.allTrue(
      result.select.p2,
      tools.oneTrue(
        tools.not(
          tools.allTrue( // rétro-compatibilité
            result.select.p2p3,
            result.select.yes(result.fields.gloves.p2p3.field)
          )
        ),
        tools.equals(result.fields.glovesPutOn.p2p3.field, 3)
      )
    )
  )
)

// +++ ADD       handHygieneBeforePrepaOrInstall (list)
// +++ ADD       handHygieneBeforePrepaOrInstallType (list)
// +++ ADD       handHygieneBeforePrepaOrInstallCompliant (list)
result.fields.handHygieneBeforePrepaOrInstall = {
  p3b2: result.build.handHygiene(
    fields.handHygiene, 'BeforePrepaOrInstall',
    `avant la préparation du matériel et/ou l'installation du patient`,
    result.select.p3b2,
    null,
    go.fields.handHygieneTypeSimple
  )
}

// +++ ADD       handHygieneBeforeP3Gloves (list)
// +++ ADD       handHygieneBeforeP3GlovesType (list)
// +++ ADD       handHygieneBeforeP3GlovesCompliant (list)
// +++ ADD       handHygieneBeforeB2Gloves (list)
// +++ ADD       handHygieneBeforeB2GlovesType (list)
// +++ ADD       handHygieneBeforeB2GlovesCompliant (list)
result.fields.handHygieneBeforeGloves = {
  p3: result.build.handHygiene(
    fields.secondaryHandHygiene, 'BeforeP3Gloves',
    `immédiatement avant d'enfiler les gants`,
    tools.allTrue(
      result.select.p3,
      result.select.yes(result.fields.gloves.p2p3.field),
      tools.equals2(result.fields.glovesPutOn.p2p3.field, 2, 3)
    ),
    null,
    go.fields.handHygieneTypeSimple
  ),
  b2: result.build.handHygiene(
    fields.secondaryHandHygiene, 'BeforeB2Gloves',
    `avant d'enfiler les gants`,
    tools.allTrue(
      result.select.b2,
      result.select.yes(result.fields.gloves.b2.field),
      tools.equals(result.fields.glovesPutOnManip.b2.field, 2)
    ),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// >>> UPDATE    handHygieneBeforePuncture (list)handHygieneBeforePuncture>selectList>0/0: different function names "allTrue ((obsManagment === 3), (p2p3gloves === 2))" "(obsManagment === 3)}"
result.fields.handHygieneBeforePuncture.p3 = result.build.handHygiene(
  fields.thirdHandHygiene, 'BeforePuncture',
  `immédiatement avant la ponction`,
  tools.allTrue(
    result.select.p3,
    result.select.no(result.fields.gloves.p2p3.field)
  ), null, go.fields.handHygieneTypeSimple
)

// +++ ADD       handHygieneBeforeB2ManipNoGloves (list)
// +++ ADD       handHygieneBeforeB2ManipNoGlovesType (list)
// +++ ADD       handHygieneBeforeB2ManipNoGlovesCompliant (list)
result.fields.handHygieneBeforeManipNoGloves = {
  b2: result.build.handHygiene(
    fields.thirdHandHygiene, 'BeforeB2ManipNoGloves',
    'avant la désinfection du site de branchement',
    tools.allTrue(
      result.select.b2,
      result.select.no(result.fields.gloves.b2.field)
    ),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// --- REMOVE    p1insertiongloves (list)
delete result.fields.insertionGloves

// --- REMOVE    p1insertionglovesType (list)
delete result.fields.insertionGlovesType

// +++ ADD       handHygieneBeforeImplementation (list)
// +++ ADD       handHygieneBeforeImplementationType (list)
// +++ ADD       handHygieneBeforeImplementationCompliant (list)
result.fields.handHygieneBeforeImplementation = {
  r1: result.build.handHygiene(
    fields.thirdHandHygiene, 'BeforeImplementation',
    'avant la mise en place du nouveau pansement',
    tools.allTrue(result.select.r1, result.select.noGloves('r1', 'implementation')),
    null,
    go.fields.handHygieneTypeSimple
  )
}

// >>> UPDATE    r1implementationgloves (list)r1implementationgloves>config>title: different values (Port de gants pour la mise en place du nouveau pansement / Gants enfilés pour la mise en place du pansement)
result.fields.implementationGloves.r1.config.title = 'Port de gants pour la mise en place du nouveau pansement'

// --- REMOVE    p1fourthGlovesRemoval (list)
delete result.fields.fourthGlovesRemoval.p1

// >>> UPDATE    p1glovesRemoval (list) p1glovesRemoval>config>title: different values (Retrait des gants après avoir touché l'échographe (ou d'une paire si double gantage) / Retrait des gants à la fin du repérage (ou d'une paire si double gantage))
// >>> UPDATE    p1glovesRemoval (list) p1glovesRemoval>selectList>0/0: different function names "allTrue ((probeTouchedWith === 1), allTrue ((obsManagment === 1), (p1gloves === 1)))" "}"
result.fields.glovesRemoval.p1.config.title = `Retrait des gants après avoir touché l'échographe (ou d'une paire si double gantage)`
result.fields.glovesRemoval.p1 = tools.select(
  result.fields.glovesRemoval.p1,
  tools.allTrue(
    tools.equals(result.fields.probeTouchedWith.p1.field, 1),
    tools.allTrue(
      result.select.p1,
      result.select.yes(result.fields.gloves.p1.field)
    )
  )
)

// --- REMOVE    chpSwabbing (list)
delete result.fields.chpSwabbing

// --- REMOVE    chpSwabNumber (numeric)
delete result.fields.chpSwabNumber

// +++ ADD       whyNotChlAlc2Percent (list)
// +++ ADD       whyNotChlAlc2PercentDetail (text)
result.fields.whyNotChlAlc2Percent = {
  p1: result.build.why(
    '', fields.whyNotChlAlc2Percent,
    `Pour un patient adulte, pourquoi l'antiseptique utilisé n'est-il-pas la chlorhexidine alcoolique 2% ?`,
    tools.allTrue(
      result.select.p1,
      result.select.yes(result.fields.isAdult.p1p2p3r1.field),
      tools.different2(result.fields.antiseptic.p1p2p3p4[1].field, 7, 8)
    ),
    go.fields.whyNotChlAlc2Percent,
    4
  )
}

// >>> UPDATE    whyNotRemoveGlovesAfterTouch (list)whyNotRemoveGlovesAfterTouch>selectList>0/0: different function names "allTrue ((obsManagment === 1), (p1glovesRemoval === 2))" "allTrue ((obsManagment === 1), (p1fourthGlovesRemoval === 2))}"
result.fields.whyNotRemoveGlovesAfterTouch.p1[0] = tools.select(
  result.fields.whyNotRemoveGlovesAfterTouch.p1[0],
  tools.allTrue(result.select.p1, result.select.no(result.fields.glovesRemoval.p1.field))
)

// >>> UPDATE    whyNCAuditedOutfit (list)whyNCAuditedOutfit>selectList>0/0: different function names "allTrue ((obsManagment === 3), oneTrue ((sterileGown === 2), (auditedCap === 2), (compliantAuditedCap === 2), (auditedMask === 2), (compliantAuditedMask === 2), (auditedCleanOutfit === 2)))" "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 3)), oneTrue ((sterileGown === 2), (auditedCap === 2), (compliantAuditedCap === 2), (auditedMask === 2), (compliantAuditedMask === 2), (auditedCleanOutfit === 2)))}"
result.rename(result.fields.whyNCAuditedOutfit, 'p1p3', 'p3')
result.fields.whyNCAuditedOutfit.p3[0] = tools.select(
  result.fields.whyNCAuditedOutfit.p3[0],
  tools.allTrue(
    result.select.p3,
    tools.oneTrue(
      result.select.no(result.fields.auditedCap.p1p3r1.field),
      result.select.no(result.fields.compliantAuditedCap.p1p3r1.field),
      result.select.no(result.fields.auditedMask.p1p3b2r1.field),
      result.select.no(result.fields.compliantAuditedMask.p1p3b2r1.field),
      result.select.no(result.fields.auditedCleanOutfit.p2p3p4b1b2.field)
    )
  )
)

// --- REMOVE    whyNotHHAfterDressingRemoval (list)
// --- REMOVE    whyNotHHAfterDressingRemovalDetail (text)
delete result.fields.whyNotHHAfterDressingRemoval

// --- REMOVE    whyNotHHAfterStabilizerGR (list)
// --- REMOVE    whyNotHHAfterStabilizerGRDetail (text)
delete result.fields.whyNotHHAfterStabilizerGR

// >>> UPDATE    whyNCPatientOutfit (list)whyNCPatientOutfit>selectList>0/0: different function names "allTrue ((obsManagment === 3), oneTrue ((patientCleanOutfit === 2), (compliantPatientMask === 2), (patientOtherSide === 2)))" "allTrue (oneTrue ((obsManagment === 3), (obsManagment === 5)), oneTrue ((patientCleanOutfit === 2), (compliantPatientMask === 2), (patientOtherSide === 2)))}"
result.rename(result.fields.whyNCPatientOutfit, 'p3b2', 'p3')
result.fields.whyNCPatientOutfit.p3[0] = tools.select(
  result.fields.whyNCPatientOutfit.p3[0],
  tools.allTrue(
    result.select.p3,
    tools.oneTrue(
      result.select.no(result.fields.patientCleanOutfit.p1p2p3p4b2.field),
      result.select.no(result.fields.compliantPatientMask.p1p3b2r1.field),
      result.select.no(result.fields.patientOtherSide.p3b2r1.field)
    )
  )
)
// >>> UPDATE    whyNotAlcool (list)    whyNotAlcool>selectList>0/0: different function names "allTrue (oneTrue (allTrue (oneTrue ((obsManagment === 2), (obsManagment === 3)), (isAdult === 1)), allTrue ((obsManagment === 6), (unitTypeMatch /^AD/))), ([1,3,4,6,9].indexOf(p1p2p3p4Antiseptic) !== -1 || (p1p2p3p4Antiseptic === 10 && Other.match(/alcoolique/i)))" "allTrue (oneTrue (allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3)), (isAdult === 1)), allTrue ((obsManagment === 6), (unitTypeMatch /^AD/))), ([1,3,4,6,9].indexOf(p1p2p3p4Antiseptic) !== -1 || (p1p2p3p4Antiseptic === 10 && Other.match(/alcoolique/i)))}"
delete result.fields.whyNotAlcool.p1p2p3p4
result.fields.whyNotAlcool.p2p3p4 = result.build.notAlcool(
  '', [1, 3, 4, 6, 9],
  tools.oneTrue(
    tools.allTrue(
      result.select.p2p3,
      result.select.yes(result.fields.isAdult.p1p2p3r1.field)
    ),
    tools.allTrue(result.select.p4, patient.select.isAd)
  ),
  'p1p2p3p4'
)

// +++ ADD       whyNotSGForPalpation (list)
// +++ ADD       whyNotSGForPalpationDetail (text)
result.fields.whyNotSGForPalpation = {
  p2: result.build.why(
    '', fields.whyNotSGForPalpation,
    `Pourquoi l'opérateur n'a-t-il pas porté de gants stériles pour la palpation
du site après l'antisepsie ?`,
    tools.allTrue(
      result.select.p2,
      result.select.yes(result.fields.palpation.p2.field),
      tools.oneTrue(
        result.select.no(result.fields.gloves.p2p3.field),
        tools.equals(result.fields.glovesType.p2p3b1.field, 1)
      )
    ),
    go.fields.whyNotGloves,
    4
  )
}

// +++ ADD       whyNotP2HH (list)
// +++ ADD       whyNotP2HHDetail (text)
// >>> UPDATE    whyNotHH (list)        whyNotHH>selectList>0/0: different function names "allTrue ((obsManagment === 6), (handHygieneBeforePeriInsertion === 2))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (handHygieneBeforePeriInsertion === 2))}"
result.fields.whyNotHH = (function () {
  const reference = result.fields.whyNotHH.p2p4[0]
  const t = reference.config.title

  return {
    p2: result.build.why(
      '', fields.whyNotP2HH, t,
      tools.allTrue(
        result.select.p2,
        result.select.no(result.fields.handHygieneBeforePeriInsertion.p2p4[0].field)
      ),
      go.fields.whyNotP2HH
    ),

    p4: result.build.why(
      '', fields.whyNotHH, t,
      tools.allTrue(
        result.select.p4,
        result.select.no(result.fields.handHygieneBeforePeriInsertion.p2p4[0].field)
      ),
      go.fields.whyNotHH
    )
  }
})()

// whyNotP2HH use a specific name, it does not follow the usual prefix rule.
// Instead of adding yet another exception in the build.why code, we fix it here.
result.fields.whyNotHH.p2[0].convert.server = result.fields.whyNotHH.p4[0].field
result.fields.whyNotHH.p2[1].convert.server = result.fields.whyNotHH.p4[1].field

// --- REMOVE    r1whyNotAlcool (list)
// --- REMOVE    r1whyNotAlcoolDetail (text)
delete result.fields.whyNotAlcool.r1

// --- REMOVE    whyNotHHC (list)
// --- REMOVE    whyNotHHCDetail (text)
delete result.fields.whyNotHHC

// +++ ADD       whyNotHHBeforeGloves (list)
// +++ ADD       whyNotHHBeforeGlovesDetail (text)
result.fields.whyNotHHBeforeGloves = {
  p3: result.build.why(
    '', fields.whyNotHHBeforeGloves,
    `Pourquoi l'hygiène des mains n'a-t-elle pas été réalisée avant d'enfiler les gants ?`,
    tools.allTrue(
      result.select.p3,
      tools.notNull(result.fields.glovesPutOn.p2p3.field),
      tools.oneTrue(
        tools.allTrue(
          tools.equals(result.fields.glovesPutOn.p2p3.field, 1),
          result.select.no(result.fields.handHygieneBeforePrepaOrInstall.p3b2[0].field)
        ),
        result.select.no(result.fields.handHygieneBeforeGloves.p3[0].field)
      )
    ),
    go.fields.whyNotHHP,
    5
  )
}

// --- REMOVE    whyNotHHP (list)
// --- REMOVE    whyNotHHPDetail (text)
delete result.fields.whyNotHHP

// >>> UPDATE    whyNotGloves (list)    whyNotGloves>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p4gloves === 2))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p2p3p4b1gloves === 2))}"
result.rename(result.fields.whyNotGloves, 'p2p4', 'p4')
result.fields.whyNotGloves.p4[0] = tools.select(
  result.fields.whyNotGloves.p4[0],
  tools.allTrue(
    result.select.p4,
    result.select.no(result.fields.gloves.p4.field)
  )
)

// >>> UPDATE    b1whyNotHHM (list)     b1whyNotHHM>config>title: different values (Pourquoi l'HDM n'a-t-elle pas été réalisée avant la désinfection du site de branchement ? / Pourquoi l'HDM n'a-t-elle pas été réalisée avant la manipulation ?)
// >>> UPDATE    b1whyNotHHM (list)     b1whyNotHHM>selectList>0/0: different function names "allTrue ((obsManagment === 4), (handHygieneBeforeB1Disinfection === 2))" "allTrue ((obsManagment === 4), (handHygieneBeforeManip === 2))}"
result.fields.whyNotHHM.b1[0].config.title = `Pourquoi l'HDM n'a-t-elle pas été réalisée avant la désinfection du site de branchement ?`
result.fields.whyNotHHM.b1[0] = tools.select(
  result.fields.whyNotHHM.b1[0],
  tools.allTrue(
    result.select.b1,
    result.select.no(result.fields.handHygieneBeforeDisinfection.b1[0].field)
  )
)

// >>> UPDATE    whyNotCompresses (list)whyNotCompresses>config>title: different values (Pourquoi l'audité n'utilise-t-il pas de compresses pour la désinfection du site de branchement ? / Pourquoi l'audité n'utilise-t-il pas de compresses pour la manipulation ?)
result.fields.whyNotCompresses.b1[0].config.title = `Pourquoi l'audité n'utilise-t-il pas de compresses pour la désinfection du site de branchement ?`

// >>> UPDATE    b2whyNotHHM (list)     b2whyNotHHM>config>title: different values (Pourquoi l'HDM n'a-t-elle pas été réalisée immédiatement avant d'enfiler les gants ou avant la désinfection du site de branchement sans gants ? / Pourquoi l'HDM n'a-t-elle pas été réalisée immédiatement avant la manipulation du site de branchement?)
// >>> UPDATE    b2whyNotHHM (list)     b2whyNotHHM>selectList>0/0: different function names "allTrue ((obsManagment === 5), oneTrue ((handHygieneBeforeB2Gloves === 2), (handHygieneBeforeB2ManipNoGloves === 2)))" "allTrue ((obsManagment === 5), (handHygieneBeforeB2Manip === 2))}"
result.fields.whyNotHHM.b2[0].config.title = `Pourquoi l'HDM n'a-t-elle pas été réalisée immédiatement avant d'enfiler les gants ou avant la désinfection du site de branchement sans gants ?`
result.fields.whyNotHHM.b2[0] = tools.select(
  result.fields.whyNotHHM.b2[0],
  tools.allTrue(
    result.select.b2,
    tools.oneTrue(
      result.select.no(result.fields.handHygieneBeforeGloves.b2[0].field),
      result.select.no(result.fields.handHygieneBeforeManipNoGloves.b2[0].field)
    )
  )
)

// +++ ADD       whyNotHHBeforeAntisepsis (list)
// +++ ADD       whyNotHHBeforeAntisepsisDetail (text)
result.fields.whyNotHHBeforeAntisepsis = {
  r1: result.build.why(
    '', fields.whyNotHHBeforeAntisepsis,
    `Pourquoi l'hygiène des mains n'a-t-elle pas été réalisée avant l'antisepsie ?`,
    tools.allTrue(
      result.select.r1,
      result.select.no(result.fields.handHygieneBeforeAntisepsis.r1[0].field)
    ),
    go.fields.whyNotHHP,
    5
  )
}

result.titles.audited = {
  all: result.build.title(
    `L'AUDITÉ`, result.fields.audited.p1, false, result.select.obs
  )
}
result.titles.ultrasound.p1.type = 'observation-subtitle'

delete result.titles.ultrasoundPreparation
delete result.titles.ultrasoundSearch

result.titles.insertionSite = {
  p1p2: result.build.title(
    `PRÉPARATION CUTANÉE DU SITE D'INSERTION (ANTISEPSIE)`,
    result.fields.handHygieneBeforeAntisepsis.p4[0],
    false,
    result.select.p1p2
  ),

  p3: result.build.title(
    `ANTISEPSIE`,
    result.fields.dirtySkin.p1p2p3p4,
    false,
    result.select.p3
  ),

  p4: result.build.title(
    `PRÉPARATION DU SITE D'INSERTION`,
    result.fields.handHygieneBeforeAntisepsis.p4[0],
    false,
    result.select.p4
  )
}

result.titles.manipulation = {
  b1b2: result.build.title(
    'DÉSINFECTION DU SITE DE BRANCHEMENT',
    result.fields.handHygieneBeforeDisinfection.b1[0],
    false,
    result.select.b1b2
  )
}

result.titles.glovesAndHH = {
  p1p2p3b2: result.build.title(
    'PORT DES GANTS ET HYGIÈNE DES MAINS',
    result.fields.gloves.p1,
    false,
    result.select.p1p2p3b2
  )
}

delete result.titles.glovesRemoval

result.titles.insertion = {
  p4: result.build.titleFrom(
    result.titles.insertion.p2p4,
    result.fields.handHygieneBeforePeriInsertion.p2p4[0],
    result.select.p4
  )
}

result.titles.newPad.r1 = result.build.title(
  `MISE EN PLACE DU NOUVEAU PANSEMENT`,
  result.fields.handHygieneBeforeImplementation.r1[0],
  false,
  result.select.r1
)
result.titles.insertionWithUltrasound.p1.type = 'observation-subtitle'
result.titles.probeHandling.p1.type = 'observation-subtitle'

result.titles.interview.all.start = result.fields.whySheathNotRemovedAfterSearch.p1[0].field

result.sheet = {
  titles: [
    result.titles.audited.all,
    result.titles.patient.p1p2p3b2r1,
    result.titles.patient.p4,
    result.titles.ultrasound.p1,
    result.titles.padRemoval.r1,
    result.titles.insertionSite.p1p2,
    result.titles.insertionSite.p4,
    result.titles.manipulation.b1b2,
    result.titles.changePad.r1,
    result.titles.insertionSite.p3,
    result.titles.glovesAndHH.p1p2p3b2,
    result.titles.insertion.p4,
    result.titles.newPad.r1,
    result.titles.insertionWithUltrasound.p1,
    result.titles.probeHandling.p1,
    result.titles.interview.all
  ],

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all
    ]),
    result.fields.isEhpad.p4,
    ...tools.addSelect(result.select.obs, [
      tools.opts(patient.unitType.v2.rw, { sp: 'unitType_v2' }),
      patient.uf
    ]),
    result.fields.place.p1,
    result.fields.otherPlace.p1,
    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.p4,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.catheterType.r1,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.r1,

    result.fields.insertionSite.p1,
    result.fields.insertionSite.r1,
    result.fields.insertionSiteDetail.p1r1,
    result.fields.manipType.b2,
    result.fields.otherManipType.b2,
    result.fields.secondManipType.b2,
    result.fields.secondOtherManipType.b2,
    result.fields.audited.p1,
    result.fields.audited.p2b1b2,
    result.fields.audited.p3p4r1,
    result.fields.auditedDetail.p3p4r1,
    result.fields.auditedDetail.p1,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3p4b1b2,
    result.fields.auditedCleanOutfitOrProt.r1,
    result.fields.sterileGown.p1,
    result.fields.sterileGown.r1,
    result.fields.auditedCap.p1p3r1,
    result.fields.compliantAuditedCap.p1p3r1,
    result.fields.auditedMask.p1p3b2r1,
    result.fields.compliantAuditedMask.p1p3b2r1,
    result.fields.auditedCap.b2,
    result.fields.compliantAuditedCap.b2,
    result.fields.isAdult.p1p2p3r1,
    result.fields.childAge.p1p2p3r1,
    result.fields.patientCleanOutfit.p1p2p3p4b2,
    result.fields.patientMask.p1p3b2r1,
    result.fields.compliantPatientMask.p1p3b2r1,
    result.fields.patientSterileField.p1r1,
    result.fields.patientOtherSide.p3b2r1,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,
    result.fields.patientHeadSterileField.p1,
    result.fields.strippingSufficient.r1,
    result.fields.bmi.r1,

    result.fields.withUltrasound.p1,
    result.fields.usAuditedSearch.p1,
    result.fields.searchGelUsed.p1,
    result.fields.vialOpeningDateWritten.p1,
    result.fields.vialOpenedSince.p1,
    result.fields.searchUltrasoundSheath.p1,
    result.fields.sheathRemoval.p1,
    ...result.fields.ultrasoundWipingSearch.p1,

    result.fields.scheduledDressingRepair.r1,
    result.fields.soiledDressing.r1,
    result.fields.dressingPeelsOff.r1,
    ...result.fields.handHygieneBeforeEquipmentPreparation.r1,
    result.fields.sterilePreparation.r1,
    result.fields.removeDressingByStretching.r1,
    result.fields.signsOfSkinIrritation.r1,

    result.fields.removalGloves.r1,
    result.fields.removalGlovesType.r1,
    result.fields.glovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.p4,
    ...result.fields.handHygieneBeforeDisinfection.b1,

    result.fields.hasStabilizer.r1,
    result.fields.changeStabilizer.r1,
    result.fields.changeStabilizerReason.r1,

    ...result.fields.handHygieneBeforeStabilizer.r1,

    result.fields.stabilizerGloves.r1,
    result.fields.stabilizerGlovesType.r1,
    result.fields.secondaryGlovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.r1,
    result.fields.repairGloves.r1,
    result.fields.repairGlovesType.r1,

    result.fields.dirtySkin.p1p2p3p4,
    result.fields.insertionSiteCleaned.p1p2p3p4r1,
    result.fields.soap.r1,
    result.fields.rinsing.r1,
    result.fields.dryingWithSterileCompresses.r1,

    ...result.fields.antiseptic.p1p2p3p4,
    ...result.fields.antiseptic.r1,

    result.fields.useCompresses.r1,
    result.fields.useCompresses.p1p2p3p4,
    result.fields.useCompresses.b1b2,

    result.fields.compressesType.r1,
    result.fields.compressesType.p1p2p3p4,
    result.fields.compressesType.b1b2,

    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,

    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p4,

    result.fields.dry.p1p2p3p4,
    result.fields.dry.r1,
    result.fields.thirdGlovesRemoval.r1,
    result.fields.preFencedSterileField.p3,

    result.fields.glovesNecessary.b1,
    result.fields.gloves.p1,
    result.fields.gloves.p2p3,
    result.fields.gloves.b1,
    result.fields.gloves.b2,

    result.fields.glovesType.p1,
    result.fields.glovesType.p2p3b1,
    result.fields.glovesType.b2,

    result.fields.glovesPutOn.p1,
    result.fields.glovesPutOn.p2p3,
    result.fields.glovesPutOnManip.b2,
    result.fields.palpation.p2,

    ...result.fields.handHygieneBeforeInsertionGloves.p1,
    ...result.fields.handHygieneBeforePreparation.p2,
    ...result.fields.handHygieneBeforePeriInsertion.p2p4,
    ...result.fields.handHygieneBeforePrepaOrInstall.p3b2,
    ...result.fields.handHygieneBeforeGloves.p3,
    ...result.fields.handHygieneBeforeGloves.b2,
    ...result.fields.handHygieneBeforePuncture.p3,
    ...result.fields.handHygieneBeforeManipNoGloves.b2,

    result.fields.gloves.p4,
    result.fields.glovesType.p4,
    result.fields.holdTissue.p4,

    ...result.fields.handHygieneBeforeImplementation.r1,

    result.fields.implementationGloves.r1,
    result.fields.implementationGlovesType.r1,
    result.fields.insertionUltrasoundSheath.p1,
    result.fields.probeCovered.p1,
    result.fields.sheathJustBeforeInsertion.p1,
    result.fields.insertionGelUsed.p1,
    result.fields.gelApplied.p1,
    result.fields.probeNeedleContact.p1,
    result.fields.auditedTouchProbe.p1,
    result.fields.probeTouchedWith.p1,
    result.fields.probeTouchedWithDetail.p1,

    result.fields.glovesRemoval.p1,

    result.fields.nakedEyeSheathInspection.p1,
    result.fields.probeInspection.p1,
    result.fields.tearedSheath.p1,
    result.fields.dirtyProbe.p1,
    result.fields.probeCleaned.p1,
    result.fields.probeCleaningMethod.p1,
    result.fields.probeCleaningMethodDetail.p1,
    ...result.fields.probeCleaningProduct.p1,

    ...result.fields.whySheathNotRemovedAfterSearch.p1,
    ...result.fields.whyNotChlAlc2Percent.p1,
    ...result.fields.whyNotRemoveGlovesAfterTouch.p1,
    ...result.fields.whyNCAuditedOutfit.p3,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3,
    ...result.fields.whyNotAlcool.p2p3p4,
    ...result.fields.whyNotSGForPalpation.p2,
    ...result.fields.whyNotHH.p2,
    ...result.fields.whyNotHH.p4,

    ...result.fields.whyNotHHCompliant.p2,
    ...result.fields.whyNotHHBeforeGloves.p3,
    ...result.fields.whyNotGloves.p4,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2,
    ...result.fields.whyNotSterileGloves.b2,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotGROnStabilizerChange.r1,
    ...result.fields.whyNotHHBeforeAntisepsis.r1,
    ...result.fields.whyNotSGForAntisepsis.r1
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v2.rw.field,
        isAdult: result.fields.isAdult.p1p2p3r1.field,
        childAge: result.fields.childAge.p1p2p3r1.field
      }
    )

    checkDate(
      resultNotes, sheet, '2024', {
        obsDate: result.fields.obsDate.all
      }
    )

    checkCompresses(
      resultNotes, sheet, {
        antiseptic: result.fields.antiseptic.p1p2p3p4[1].field,
        useCompresses: result.fields.useCompresses.p1p2p3p4.field
      }
    )

    checkCompresses(
      resultNotes, sheet, {
        antiseptic: result.fields.antiseptic.r1[1].field,
        useCompresses: result.fields.useCompresses.r1.field
      },
      'r1'
    )

    checkB2Gloves(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotHHM: result.fields.whyNotHHM.b2[0].field,
        gloves: result.fields.gloves.b2.field
      }
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        insertionSite: result.fields.insertionSite.p1.field
      },
      'p1'
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 7, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.r1.field,
        insertionSite: result.fields.insertionSite.r1.field
      },
      'r1'
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1.field
      },
      result.fields.glovesRemoval.p1
    )

    checkBMI(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    checkP1Chlorex(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        whyNotChlAlc2Percent: result.fields.whyNotChlAlc2Percent.p1[0].field
      }
    )

    checkSecondManipType(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        manipType: result.fields.manipType.b2.field,
        secondManipType: result.fields.secondManipType.b2.field,
        otherManipType: result.fields.otherManipType.b2.field,
        secondOtherManipType: result.fields.secondOtherManipType.b2.field
      }
    )

    checkHeadFaceSterileField(
      resultNotes, sheet, {
        patientHeadSterileField: result.fields.patientHeadSterileField.p1.field,
        patientSterileField: result.fields.patientSterileField.p1r1.field
      }
    )
    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2024')
export default ice.freeze(result, 10)
